function Field({ label, required, hint, children }) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[10px] uppercase tracking-[0.15em] text-[#978D78] font-bold">
        {label} {required && <span className="text-red-500">*</span>}
      </span>
      {children}
      {hint && <span className="text-[10px] text-[#9CA3AF]">{hint}</span>}
    </label>
  );
}

const INPUT_CLS = "px-3 py-2 text-sm border border-[#E6E1D6] rounded outline-none focus:border-[#0F1829] w-full";

export default function PaymentForm({
  data, setData, valor, setValor, tipo, setTipo, obs, setObs, types,
}) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <Field label="Data" required>
        <input type="date" value={data} onChange={(e) => setData(e.target.value)}
          className={INPUT_CLS} data-testid="register-payment-date" />
      </Field>
      <Field label="Valor (€)" required hint="Negativo para estorno/correcção">
        <input type="number" step="0.01" value={valor} onChange={(e) => setValor(e.target.value)}
          className={`${INPUT_CLS} font-mono`} data-testid="register-payment-value" />
      </Field>
      <Field label="Tipo Pagamento" required>
        <select value={tipo} onChange={(e) => setTipo(e.target.value)}
          className={`${INPUT_CLS} bg-white`} data-testid="register-payment-type">
          <option value="" disabled>— Escolhe —</option>
          {types.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
        </select>
      </Field>
      <Field label="Observações">
        <input type="text" value={obs} onChange={(e) => setObs(e.target.value)}
          placeholder="ex: Transferência ref. Janeiro"
          className={INPUT_CLS} data-testid="register-payment-obs" />
      </Field>
    </div>
  );
}
